export const cursorConstants = {
  CURSOR_UPDATE: 'CURSOR_UPDATE',
};
